import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { MyPDFDownloader } from 'src/app/constants/download-pdf';
import { Profile } from 'src/app/model/profile.model';
import { Event } from 'src/app/model/event.model';
import { ExistingReservation } from 'src/app/model/reservation.model';
import { ROUTES } from 'src/app/route/routes';
import { HomeService } from 'src/app/service/home.service';
import { UserService } from 'src/app/service/user.service';
import { LocationStrategy } from '@angular/common';
import { GenericConfirmationComponent } from 'src/app/components/dialog/generic-confirmation/generic-confirmation.component';
import { MatDialog } from '@angular/material/dialog';
import { BookingService } from 'src/app/service/booking.service';
import { LANGUAGES } from 'src/app/constants/lang';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { FluxService } from 'src/app/service/flux-service';

@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ReservationComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  private pdfDownloader: MyPDFDownloader = new MyPDFDownloader();
  public reservation: any;

  userLanguage: string;
  idReservation?: string;
  isEditable: boolean = false;

  public languages = LANGUAGES;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private spinner: SpinnerService,
    private homeService: HomeService,
    public userService: UserService,
    private location: LocationStrategy,
    private bookingService: BookingService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private fluxService: FluxService,
  ) {
    this.userLanguage = this.userService.lang;
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.userLanguage = event.lang;
    });
  }

  ngOnInit(): void {
    this.fluxService.initializeFromRoute(this.route);
    this.reservation = this.homeService.getReservationObject();
    // console.log(this.reservation)
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goBack() {
    this.location.back();
    // this.route.navigate([ROUTES.RESERVATION_LIST.absolute_path])
  }

  eventSelected(val: any) {
    const currentFlux = this.fluxService.getCurrentFlux();
    let newEvent: Event = new Event(
      this.reservation.uuid_event,
      this.reservation.event_name,
      this.reservation.event_location,
      this.reservation.event_short_description,
      this.reservation.event_long_description,
      val.event_dates,
      val.is_waiting_list!
    );
    this.homeService.saveEventObject(newEvent);

    let mockProfile: Profile = new Profile(
      val.displayName,
      val.badgeNumber,
      true,
      true,
      val.uuid_passenger,
      val.uuid_employee
    );
    this.homeService.saveProfileObject([mockProfile]);

    let oldReservation: ExistingReservation = {
      uuid_old_reservation: val.uuid_reservation,
      old_number_of_users: val.number_of_users,
      uuid_old_event_occurrence: val.uuid_event_occurrence,
    };
    this.homeService.saveEditReservationObject(oldReservation);
    setTimeout(() => this.router.navigate([currentFlux+'/'+ROUTES.EVENT_CALENDAR.path]), 200);
  }

  // per ora viene tolto per lasciare spazio ai pulsanti diretti di modifica e cancella
  // download(index: number) {
  //   this.pdfDownloader.downloadTickets(
  //     {
  //       event_name: this.reservation.event_name,
  //       event_datetime:
  //         this.reservation.associated_reservations[index].event_ticket_datetime,
  //       event_ticket_file_name:
  //         this.reservation.associated_reservations[index].ticket_file_name,
  //       event_long_description: this.reservation.event_long_description,
  //     },
  //     [
  //       {
  //         displayName:
  //           this.reservation.associated_reservations[index].displayName,
  //         badgeNumber:
  //           this.reservation.associated_reservations[index].badgeNumber,
  //       },
  //     ],
  //     this.userService.lang!
  //   );
  // }

  goTo(path: string, rev?: any) {
    const currentFlux = this.fluxService.getCurrentFlux();
    switch (path) {
      case 'reservations': {
        this.router.navigate([currentFlux+'/'+ROUTES.RESERVATION_LIST.path]);
        break;
      }

      case 'edit': {
        this.router.navigate([currentFlux+'/'+ROUTES.EVENT_CALENDAR.path]);
        break;
      }

      case 'delete': {
        this.spinner.show();
        this.bookingService.deleteReservation(rev.uuid_reservation).subscribe({
          next: (res) => {
            this.router.navigate([currentFlux+'/'+ROUTES.EVENT_DELETE.path]);
          },
          error: (err) => {
            console.error(err);
            this.showError();
            this.spinner.hide();
          },
        });
        break;
      }

      case 'home': {
        this.router.navigate([ROUTES.HOME.path]);
        break;
      }
    }
  }

  showConfirmDelete(rev: any, message?: string) {
    if (!message) message = 'edit_booking.confirm_delete';

    const dialogRef = this.dialog.open(GenericConfirmationComponent, {
      data: {
        isConfirmDialog: true,
        message: message,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.goTo('delete', rev);
      }
    });
  }

  private showError(message?: string) {
    if (!message) message = 'edit_booking.show_error';

    const dialogRef = this.dialog.open(GenericConfirmationComponent, {
      data: {
        message: message,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.goTo('home');
    });
  }
}
